// extracted by mini-css-extract-plugin
export default {"formControl":"widgets-contacts-and-settings-fields-Phone-InternationalPhone-InternationalPhoneField__formControl--pASnk"};